{
  "viewMore": "View more",
  "or": "or",

  "appTitle": "Report + Support",
  "supportTitle": "Support",
  "campaignsTitle": "Campaigns",
  "reportTitle": "Report",
  "cookieControlLink": "Cookie Control",
  "insightsTitle": "Insights reports",

  "cultureShift": "Culture Shift",
  "homeTitle": "Support",
  "menuLabel": "Menu",
  "closeMenuLabel": "Close menu",
  "skipToContent": "Skip to content",

  "licensedBy": "Licensed by",
  "connectWithUs": "Connect With Us",
  "emailUs": "Email us",
  "getInTouch": "Get in touch",
  "viewOnMap": "View on map",
  "address": "Address",

  "cookieControlTitle": "Cookie settings",
  "cookieControlBody": "We’d like to set analytics cookies to help us improve our website by collecting and reporting information on how you use it. The cookies collect information in a way that does not directly identify anyone.",
  "cookieAccept": "Accept",
  "cookieDecline": "Reject",
  "cookieAllow": "Allow analytics cookies",

  "reportCta_interval": "(0)[You can not currently report issues through this website];(1)[You can tell us what happened through this website];(2)[There are two ways you can tell us what happened];(3)[There are three ways you can tell us what happened];(4-inf)[There are a few ways you can tell us what happened];",

  "backLabel": "Back",
  "continueLabel": "Continue",
  "reportNowLabel": "Report now",
  "skipToEndLabel": "Skip these questions",
  "skipToEndFallbackIntro": "The following questions are optional. Answering these questions will help our team track wider trends and problems.",
  "sendReportLabel": "Send report",
  "sendSurveyLabel": "Submit response",
  "thankYouTitle": "Thank You",
  "reviewAnswers": "Review your answers before sending your report",
  "reviewSurveyAnswers": "Review your answers before submitting your response",
  "questionNotAnswered": "You did not answer this question",
  "imagesAttached_one": "{{count}} image attached",
  "imagesAttached_other": "{{count}} images attached",
  "change": "Change",
  "otherPleaseSpecify": "If other, please specify",
  "additionalSupport": "Additional support",

  "messageCodeText": "You can return and speak with us at any time by saving the unique access code below.",
  "messageCodeAlert": "Make sure to keep a record of the code in a safe place as it cannot be recovered once you leave this page",
  "messageCodeCopied": "Copied",
  "messageCodeLogin": "Login",

  "messagingMessagesTab": "Messages",
  "messagingSettingsTab": "Settings",
  "alreadyReported": "Already reported?",
  "messagingCodeTitle": "Messaging",
  "messagingCodeLogInBodyHome": "If you’ve submitted a report and been given a code to speak with a caseworker you can log in below",
  "messagingLogIn": "Log in to Messaging",
  "messagingCodeLogInBody": "Enter your unique code below to login and speak with us.",
  "messagingCodeSubmit": "Submit",
  "messagingCodeInvalid": "This code is not valid",
  "messagingCode": "Access code",
  "messagingCodeHelp": "What if I don’t have an access code? If you have submitted a report and did not save the code you will need to submit a new report",
  "messagingCodeWarning": "If you didn’t make a note of your code press the back button in your browser",
  "messagingCodeDisabled": "Your account has been disabled",
  "messagingCodeDisabledByCaseworker": "Messaging disabled by the case worker",
  "messagingDisableAccountTitle": "Disable account",
  "messagingDisableAccountBody": "You can use this feature if you are concerned that your account has been compromised. By disabling your account you will permanently lose access to this logged in area, this action cannot be undone.",
  "messagingDisableAccountButton": "Disable account",
  "messagingDisableAccountConfirm": "Confirm disable account",
  "messagingDisableAccountModal": "Are you sure you want to disable your account and permanently lose access to your messages? This action cannot be undone.",

  "messagingLogoutAccountButton": "Log out",

  "downloadReport": "Download your report",
  "cancel": "Cancel",

  "reportDownloadSessionNotFoundTitle": "Error finding user session",
  "reportDownloadSessionNotFoundBody": "Sorry this user session does not appear to exist",
  "reportDownloadSessionIdNotMatching": "Sorry the report could not be downloaded",

  "reportDownloadSessionUuidInvalidTitle": "Invalid Session ID",
  "reportDownloadSessionUuidInvalidBody": "This session ID does not exist",
  "reportDownloadSessionTimeOutTitle": "Session timeout",
  "reportDownloadSessionTimeOutBody": "This user session has timed out",

  "messagingErrorTitle": "Error loading messages",
  "messagingErrorBody": "Sorry there has been an error loading messages please refresh or check back later.",

  "reporterMessagingEmptyTitle": "No messages",
  "reporterMessagingEmptyBody": "There are currently no messages, type a message in the box above.",

  "sendMessageError": "An error occurred while sending your message",
  "unexpectedErrorOnLogin": "An unexpected error occurred while logging you in",

  "reportMessagingSendMessage": "Send message",
  "reportMessagingTextAreaLabel": "Message",
  "today": "Today",
  "you": "You",
  "caseWorker": "Case worker",
  "redacted": "Redacted",
  "added": "Added",
  "notAnswered": "Not answered",
  "form": "Form",
  "yourReport": "Your report",
  "removed": "Removed",
  "reportAmended": "Some of the content in your report has been amended or redacted inline with our Privacy Notice",
  "newTab": "Open in a new tab",
  "noAnswerPermission": "You do not have permission to view this answer.",
  "invalidImage": "This image is invalid or may have been corrupted during the report upload process.",

  "filesTooLargeError": "<strong>None of your files have been uploaded</strong> because the total size exceeds the limit of <strong>{{limit}}MB</strong>",
  "imageFormatError": "<strong>None of your files have been uploaded</strong> because one or more file types are not supported. Please upload a valid image format such as <strong>jpg, png, or gif</strong>",
  "thankYouImageError_one": "Your report has been submitted, however one of the files you uploaded was not in the accepted format so has not been uploaded",
  "thankYouImageError_other": "Your report has been submitted, however {{count}} of the files you uploaded were not in the accepted format so have not been uploaded",
  "someFilesTooLargeError_one": "<strong>One of your files was not uploaded</strong> because it exceeds the limit of <strong>{{limit}}MB</strong>",
  "someFilesTooLargeError_other": "<strong>{{count}} of your files were not uploaded</strong> because they exceed the limit of <strong>{{limit}}MB</strong>",
  "someFilesNotImagesError_one": "<strong>One of your files was not uploaded</strong> because the file type is not supported. Please upload a valid image format such as <strong>jpg, png, or gif</strong>",
  "someFilesNotImagesError_other": "<strong>{{count}} of your files were not uploaded</strong> because the file types are not supported. Please upload a valid image format such as <strong>jpg, png, or gif</strong>",
  "someFilesRejectedError": "<strong>{{count}} of your files were not uploaded</strong> because they are too large or the wrong format. Please upload a valid image format such as <strong>jpg, png, or gif</strong>",
  "pageIncompleteError": "Please complete the questions before continuing",
  "selectedFileCount_one": "({{count}} image previously selected)",
  "selectedFileCount_other": "({{count}} images previously selected)",
  "sendingReport": "Uploading report...",
  "doNotCloseTab": "Please do not close this browser tab.",
  "required": "This question is required.",
  "csrfFailure": "Something went wrong. Please check your answers and try again.",
  "noCaptchaTitle": "Captcha error",
  "noCaptchaBody": "Your submission was not accepted because you did not complete the captcha",
  "NoSessionTitle": "No session found",
  "NoSessionBody": "Your submission was not accepted because you did not have a valid session",
  "duplicateSession": "You have submitted this form more than once. Only the first submission has been accepted.",
  "captchaFailed": "We were unable to verify that you are a human.",
  "captchaFailedLink": "Please try again",
  "captchaLoading": "Please wait while the Captcha loads...",
  "captchaPassed": "I am not a robot",
  "noAnswersTitle": "Something went wrong",
  "noAnswersBody": "Your submission was not accepted because you did not answer any questions. Please try again",

  "maxCharacters": "Maximum {{count}} characters",
  "charactersLeft_one": "{{count}} character left",
  "charactersLeft_other": "{{count}} characters left",
  "charactersOver_one": "{{count}} character over",
  "charactersOver_other": "{{count}} characters over",
  "maxCharactersShorthand": "{{used}}/{{limit}} characters",
  "maxCharactersError": "Please limit your answer to {{count}} characters",

  "errorSummaryTitle_one": "There is a problem with the following question",
  "errorSummaryTitle_other": "There is a problem with the following questions",

  "errorLabelTitle": "Error:",
  "textQuestionInvalid": "Please enter an answer",
  "emailQuestionInvalid": "Please enter a valid email address",
  "phoneQuestionInvalid": "Please enter a valid phone number",
  "imageQuestionInvalid": "Please upload any required images",
  "radioQuestionInvalid": "Please choose an option from the list",
  "checkboxQuestionInvalid": "Please choose one or more options from the list",
  "defaultQuestionInvalid": "Please complete this question",

  "notFoundTitle": "Not Found",
  "pageNotFoundBody": "Sorry, there is no content at this location.",

  "siteSuspended": "Site suspended",
  "unexpectedInputTitle": "Unexpected input",
  "unexpectedInputBody": "We were not able to process your input. The error has been reported so please try again soon. If you require urgent support please contact security or the emergency services.",
  "internalServerErrorTitle": "Internal Server Error",
  "internalServerErrorBody": "Something has gone wrong. The error has been reported so please check back soon. If you require urgent support please contact security or the emergency services.",

  "maintenanceTitle": "Site down for maintenance",
  "maintenanceBody": "The site is currently down for planned maintenance. Please check back shortly. If you require urgent support please contact security or the emergency services.",

  "auth": {
    "loading": "Loading login page...",
    "signedIn": "You are now signed in.",
    "signIn": "Sign in",
    "noProvider": "Error: This site has been configured to require a login, but no identity provider was found.",
    "holding": "Please wait to be redirected. If you are not redirected, please try again.",
    "noAuthTitle": "Login error",
    "noAuthBody": "Your submission was not accepted because you did not log in."
  }
}
